import { render, staticRenderFns } from "./LayerAddingPermissions.vue?vue&type=template&id=509b3acc&scoped=true&"
import script from "./LayerAddingPermissions.vue?vue&type=script&lang=js&"
export * from "./LayerAddingPermissions.vue?vue&type=script&lang=js&"
import style0 from "./LayerAddingPermissions.vue?vue&type=style&index=0&id=509b3acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b3acc",
  null
  
)

export default component.exports